// BSV CHANGES
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface DistanceItem {
  fromStationName: string;
  toStationName: string;
  distance: number;
  ids: number[];
}

interface ExpenseDistanceState {
  loading: boolean;
  data: DistanceItem[];
  error: string | null;
}

const initialState: ExpenseDistanceState = {
  loading: false,
  data: [],
  error: null,
};


const expenseDistanceSlice = createSlice({
  name: 'expenseDistance',
  initialState,
  reducers: {
    getDistanceRequest: (state, _action: PayloadAction<{fromStation: string; toStation: string}>) => {
      state.loading = true;
      state.error = null;
    },
    getDistanceSuccess: (state, action: PayloadAction<DistanceItem[]>) => {
      state.loading = false;
      state.data = action.payload;
    },
    getDistanceFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    postDistanceRequest: (state, _action: PayloadAction<{ ids: number[]; distance: number }[]>) => {
      state.loading = true;
      state.error = null;
    },
    postDistanceSuccess: (state) => {
      state.loading = false;
    },
    postDistanceFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearDistanceData: (state) => {
      state.data = [];
      state.error = null;
      state.loading = false;
    },
  },
});

export const expenseDistanceReducer = expenseDistanceSlice.reducer;
export const {
  getDistanceRequest,
  getDistanceSuccess,
  getDistanceFailure,
  postDistanceRequest,
  postDistanceSuccess,
  postDistanceFailure,
  clearDistanceData,
} = expenseDistanceSlice.actions;